// Register your feature flags here with a key for localStorage and a title
export const flags = {
  feature_new_insights_page: 'New Insights page',
  feature_gated_embed: 'Gated embed',
};
